import { subscriptionsStorePath } from '@lingoda/router';
import { Box, Button, Stack, Typography, styled } from '@lingoda/ui';
import { actionClick, useUiEvent } from '@lingoda/analytics';
import { trans } from '@lingoda/i18n';
import ChangeSubIllustration from './change-subscription.svg?component';

export const ChangeSubscriptionBanner = () => {
    const addEvent = useUiEvent();

    return (
        <InfoBox>
            <Stack spacing={1} alignItems="flex-start" flex={1} p={3}>
                <Typography variant="h2">
                    {trans('banner-change-subscription-title', {}, 'student-store')}
                </Typography>
                <Typography variant="body1" htmlColor="text.secondary">
                    {trans('banner-change-subscription-subtitle', {}, 'student-store')}
                </Typography>
                <Button
                    color="primary"
                    variant="outlined"
                    onClick={() => addEvent(actionClick('ChangeYourSubscriptionClick'))}
                    href={subscriptionsStorePath()}
                    sx={{ mt: 2 }}
                >
                    {trans('banner-change-subscription-cta', {}, 'student-store')}
                </Button>
            </Stack>
            <ChangeSubIllustration />
        </InfoBox>
    );
};

const InfoBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.colors.brand.beige,
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
    },
}));
